import React from "react";
import {
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	UseDisclosureProps,
} from "@chakra-ui/react";
import { Button } from "newui/components/Button";

interface ModalDeleteSectionProps {
	isOpen: boolean;
	onClose: () => void;
	OptionSections?: any; // You can narrow this type later if it's a specific object or array
}

export const ModalDeleteSection: React.FC<ModalDeleteSectionProps> = ({
	isOpen,
	onClose,
	OptionSections,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size="md"
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>
					<h2 className="text-lg font-semibold text-primary-900">
						Delete section
					</h2>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<p>Are you sure you want to delete the section?</p>
					<p>This action could delete all questions within this section.</p>
				</ModalBody>

				<ModalFooter>
					<Flex
						gap={3}
						className="!w-full"
					>
						<Button
							btntype="base"
							style={{ width: "100%" }}
							onClick={onClose}
						>
							Cancel
						</Button>
						<Button
							btntype="secondary-danger"
							style={{ width: "100%" }}
						>
							Delete
						</Button>
					</Flex>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default ModalDeleteSection;
